import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const StressIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M21.3 8.9c.6-.1 1.1.1 1.5.5s.6 1 .5 1.5c-.5 5.3-3.9 9.9-8.9 11.8-.7.3-1.5.4-2.2.6H12c-.8-.1-1.5-.3-2.2-.6-5-1.9-8.5-6.5-8.9-11.8-.1-.6.1-1.1.5-1.5s.9-.6 1.5-.5C4 9 5 9.2 6 9.6c2.3 1 4.2 2.6 5.5 4.7l.6.9.6-.9c1.3-2.1 3.3-3.7 5.6-4.7.8-.4 1.9-.6 3-.7zM10.5 1.5c.6-.9 1.9-1 2.7-.4.2.1.3.3.4.4 1.4 1.8 2.4 4 2.9 6.3-1.8 1-3.3 2.3-4.5 4-1.2-1.6-2.7-2.9-4.5-3.8.4-2.4 1.5-4.6 3-6.5z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconBase>
  );
};

export default StressIcon;
